import React, { useState } from 'react';
import ArchetypeQuiz from './ArchetypeQuiz';
import ArchetypeDashboard from './ArchetypeDashboard';
import ArchetypeBadge from './ArchetypeBadge';
import { useArchetype } from '../../contexts/ArchetypeContext';

const ArchetypeTest = () => {
    const { archetype, openQuiz } = useArchetype();
    const [showQuiz, setShowQuiz] = useState(false);

    const handleOpenQuiz = () => {
        setShowQuiz(true);
    };

    const handleQuizComplete = (result) => {
        setShowQuiz(false);
        console.log('Quiz completed:', result);
    };

    const handleClose = () => {
        setShowQuiz(false);
    };

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Sistema de Arquetipos - Test</h1>

            {/* Test Controls */}
            <div className="mb-6 p-4 bg-gray-100 rounded-lg">
                <h2 className="text-lg font-semibold mb-4">Controles de Prueba</h2>
                <div className="space-y-2">
                    <button
                        onClick={handleOpenQuiz}
                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                    >
                        Abrir Cuestionario
                    </button>
                    <button
                        onClick={openQuiz}
                        className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 ml-2"
                    >
                        Abrir Quiz (Context)
                    </button>
                </div>
            </div>

            {/* Current Archetype */}
            <div className="mb-6 p-4 bg-white border rounded-lg">
                <h2 className="text-lg font-semibold mb-4">Arquetipo Actual</h2>
                {archetype ? (
                    <div>
                        <ArchetypeBadge archetype={archetype} />
                        <pre className="mt-4 p-4 bg-gray-100 rounded text-sm overflow-auto">
                            {JSON.stringify(archetype, null, 2)}
                        </pre>
                    </div>
                ) : (
                    <p className="text-gray-500">No hay arquetipo asignado</p>
                )}
            </div>

            {/* Archetype Dashboard */}
            <div className="mb-6">
                <h2 className="text-lg font-semibold mb-4">Dashboard de Arquetipo</h2>
                <ArchetypeDashboard
                    archetype={archetype}
                    onOpenQuiz={handleOpenQuiz}
                />
            </div>

            {/* Quiz Modal */}
            {showQuiz && (
                <ArchetypeQuiz
                    onComplete={handleQuizComplete}
                    onClose={handleClose}
                />
            )}
        </div>
    );
};

export default ArchetypeTest; 